// @ vendors
import React from 'react';

const PropTypes = require('prop-types');
// components
import Microfrontend from './dynamicLoad/dynamicLoad.microfrontend';

const BaseMicrofrontendRoute = ({ microfrontend, ...props }) => (
    <Microfrontend vertical={microfrontend} {...props} />
);

BaseMicrofrontendRoute.propTypes = {
    microfrontend: PropTypes.shape({
        proxy: PropTypes.string,
        id: PropTypes.string
    }),
};

export default React.memo(BaseMicrofrontendRoute);
